import { render, staticRenderFns } from "./DeliveryReminder.vue?vue&type=template&id=226c083d&scoped=true&"
import script from "./DeliveryReminder.vue?vue&type=script&lang=js&"
export * from "./DeliveryReminder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReminder.vue?vue&type=style&index=0&id=226c083d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c083d",
  null
  
)

export default component.exports